import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "pleiades_token";
export const CLIENT_PREVIEW_TOKEN_KEY = "pleiades_admin_client_preview_token";
export const CLIENT_PREVIEW_LINK_KEY = "pleiades_admin_client_preview_link";

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const isClientPortalRequest = String(config.url || "").startsWith("/client-portal/");
  const previewToken = isClientPortalRequest
    ? sessionStorage.getItem(CLIENT_PREVIEW_TOKEN_KEY)
    : null;
  const token = previewToken || localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const API_ERROR_MESSAGES = {
  questionnaire_not_published:
    "Anket henüz kullanıma hazır değil. Lütfen yöneticiyle iletişime geçin.",
  work_rules_not_published:
    "Çalışma kuralları henüz kullanıma hazır değil. Lütfen yöneticiyle iletişime geçin.",
  work_catalog_not_published:
    "Çalışma kataloğu henüz kullanıma hazır değil. Lütfen yöneticiyle iletişime geçin.",
  daily_program_disabled:
    "Günlük çalışma sistemi şu anda kullanıma hazır değil.",
};

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Bir hata oluştu";
  if (typeof detail === "string") return API_ERROR_MESSAGES[detail] || detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  }
  return String(detail);
}
